import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LikeFilledSvg from "@ant-design/icons-svg/es/asn/LikeFilled";
import AntdIcon from "../components/AntdIcon";
var LikeFilled = function LikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LikeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LikeFilled.displayName = 'LikeFilled';
}
export default /*#__PURE__*/React.forwardRef(LikeFilled);